import type { ID, Scalar, Option as OptionType } from "types";
import { Option } from "util/option";
import type { WithProductsAndServices } from "./types";

export class BusinessActivityOption extends Option implements WithProductsAndServices<OptionType> {
    public static Other = 'other';

    public static appendWithOption(options: Array<OptionType> | null | undefined, append: OptionType) {
        if (options) {
            return [
                ...options,
                append
            ];
        }

        return [append];
    }

    public static from(id: ID, name?: Scalar<string>) {
        return new this(
            this.make(id, name)
        );
    }

    public readonly id: OptionType['id'];
    public readonly name: OptionType['name'];
    public productsAndServices: Array<OptionType> = [];

    private constructor({ id, name }: OptionType) {
        super();

        this.id = id;
        this.name = name;
    }

    public withProductsAndServices(productsAndServices: Array<OptionType>) {
        this.productsAndServices = productsAndServices;

        return this;
    }
}
